import { useNavigate } from "react-router-dom";
import { Icon } from "./Icons";
import type { Todo } from "../lib/todos";

/* A short, prioritised list of what needs attention — shared by the studio
   dashboard (per project) and the client portal overview. */
export function ActionCenter({ items, base, title = "Needs attention", onItem }: { items: Todo[]; base?: string; title?: string; onItem?: (section: string) => void }) {
  const nav = useNavigate();
  if (!items.length) return null;
  const urgent = items.filter((t) => t.urgent).length;
  const goTo = (section: string) => onItem ? onItem(section) : base && nav(`${base}/${section}`);
  return (
    <div className="card pad reveal" style={{ marginBottom: 22, borderLeft: "3px solid var(--accent)" }}>
      <div className="row between" style={{ marginBottom: 10 }}>
        <div className="row" style={{ gap: 8 }}><Icon.bell width={16} style={{ color: "var(--accent-ink)" }} /><span className="kicker">{title}</span></div>
        <span className="dim" style={{ fontSize: 12 }}>{items.length} item{items.length === 1 ? "" : "s"}{urgent ? ` · ${urgent} urgent` : ""}</span>
      </div>
      <div className="col" style={{ gap: 8 }}>
        {items.map((t) => (
          <button key={t.key} className="panel row between" onClick={() => goTo(t.section)}
            style={{ padding: "10px 14px", cursor: "pointer", textAlign: "left", gap: 10, borderColor: t.urgent ? "color-mix(in srgb, var(--danger) 40%, var(--line))" : "var(--line)" }}>
            <span className="row" style={{ gap: 10, minWidth: 0 }}>
              <span style={{ width: 7, height: 7, borderRadius: 7, background: t.urgent ? "var(--danger)" : "var(--ink-3)", flexShrink: 0 }} />
              <span style={{ fontSize: 13.5, fontWeight: 500 }}>{t.label}</span>
              {t.detail && <span className="dim" style={{ fontSize: 12 }}>· {t.detail}</span>}
            </span>
            <Icon.arrowUpRight width={14} style={{ color: "var(--ink-3)", flexShrink: 0 }} />
          </button>
        ))}
      </div>
    </div>
  );
}
